export const mapMerchantDetailsToFormValues = (details) => {
  if (!details) return null;

  return {
    merchantName: details.merchantName || "",
    merchantAlias: details.accountAlias || "",
    registrationNumber: details.registrationNumber || "",
    nationality: details.nationality || "",
    address: details.address || "",
    country: details.country || null,
    city: details.city || "",
    county: details.county || "",
    taxPin: details.taxPin || "",
    directors: details.directors || "",
    shareholders: details.shareholders || "",
    merchantType: details.merchantType || null,
    currency: details.currency || null,
    registrationDate: details.registrationDate || "",
    email: details.email || "",
    phoneNumber: details.phoneNumber || "",
    economicSector: details.economicSector || null,
    gender: details.gender || null,
    productTransactionCode: details.productTransactionCode || null,
    productOwnership: details.productOwnership || null,
    productCategory: details.productCategory || null,
  };
};

export const mapFormValuesToMerchantPayload = (formValues) => {
  if (!formValues) return null;

  return {
    ...formValues,
    // Map merchantAlias back to accountAlias if needed by API
    accountAlias: formValues.merchantAlias,
  };
};

export default {
  mapMerchantDetailsToFormValues,
  mapFormValuesToMerchantPayload,
};
